import { render, staticRenderFns } from "./branch-atm-widget-wrapper.vue?vue&type=template&id=03ccab62&lang=pug"
import script from "./branch-atm-widget-wrapper.vue?vue&type=script&lang=js"
export * from "./branch-atm-widget-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports